import { useEffect, useState } from 'react';
import { projectFirestore } from '../firebase/config';

export const useDocument = (collection, id) => {
  const [document, setDocument] = useState(null);
  const [error, setError] = useState(null);

  //Realtime Data for a single document
  useEffect(() => {
    const ref = projectFirestore.collection(collection).doc(id);

    const unsubscribe = ref.onSnapshot(
      (snapshot) => {
        if (snapshot.data()) {
          setDocument({ ...snapshot.data(), id: snapshot.id });
          setError(null);
        } else {
          setError('Project does not exist');
        }
      },
      (err) => {
        console.log(err.message);
        setError('Could not fetch the Project');
      }
    );

    return () => unsubscribe();
  }, [collection, id]);

  return { document, error };
};
